import React from "react";
import PageHero from "@/components/site/PageHero";
import { Reveal } from "@/components/primitives";
import { useSeo } from "@/lib/useSeo";
import { COMPANY } from "@/lib/content";

export default function Legal({ page }) {
  useSeo({
    title: page.title,
    description: page.intro,
    breadcrumb: [
      { name: "Home", path: "/" },
      { name: page.title, path: `/${page.slug}` },
    ],
  });

  return (
    <>
      <PageHero overline={page.overline} title={page.title} sub={page.intro} />
      <section className="relative pb-28">
        <div className="mx-auto max-w-3xl px-5 sm:px-8">
          <div className="space-y-8">
            {page.sections.map((s, i) => (
              <Reveal key={i} delay={i * 0.03}>
                <article className="glass rounded-2xl p-7">
                  {s.h && (
                    <h2 className="text-xl md:text-2xl font-heading font-semibold text-white mb-3">
                      {s.h}
                    </h2>
                  )}
                  <p className="text-slate-300 leading-relaxed">{s.p}</p>
                </article>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.1}>
            <p className="mt-10 text-sm text-slate-500">
              For grievances or legal contact, please write to {COMPANY.email} or reach the
              corporate office at {COMPANY.corporateOffice}.
            </p>
          </Reveal>
        </div>
      </section>
    </>
  );
}
